module.exports = __webpack_public_path__ + "/login_ui/img/modal-close-0e5d575d20d245327561b008d75a7de8.svg";